"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path d=\"M9 2H2l3.212 5.354a9.476 9.476 0 015.353-2.746L9 2zM22 2l-3.212 5.354a9.477 9.477 0 00-5.353-2.746L15 2h7z\" fill=\"#000\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20 14a8 8 0 11-16 0 8 8 0 0116 0zm-5.528 3.5L12 15.93 9.528 17.5l.652-2.96L8 12.548l2.876-.26L12 9.5l1.124 2.787 2.876.261-2.184 1.992.656 2.96z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;